let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("kHOMt"), load("hhss7"), load("Wowvf"), load("4AAsh")]).then(() => parcelRequire('YvPDh'));